import { UserButton } from "@clerk/clerk-react";

export function Header() {
  return (
    <header className="border-b border-secondary">
      <div className="container mx-auto max-w-4xl py-4 flex justify-between items-center">
        <img src="/logo.svg" alt="Logo" className="h-16" />
        <div className="scale-150">
          <UserButton />
        </div>
      </div>
    </header>
  );
} 